import React from "react";

const ICalendar = ({
  color = "#252526",
  width = "12",
  height = "12",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        d="M1.875 10.125H10.125V4.375H1.875V10.125ZM10.875 10.25C10.875 10.5952 10.5952 10.875 10.25 10.875H1.75C1.40482 10.875 1.125 10.5952 1.125 10.25V3.625H10.875V10.25Z"
        fill={color}
      />
      <path
        d="M1.875 3.625H10.125V2.375H1.875V3.625ZM10.875 4.375H1.125V2.25C1.125 1.90482 1.40482 1.625 1.75 1.625H10.25C10.5952 1.625 10.875 1.90482 10.875 2.25V4.375Z"
        fill={color}
      />
      <path
        d="M2.625 2.5V1.5C2.625 1.29289 2.79289 1.125 3 1.125C3.20711 1.125 3.375 1.29289 3.375 1.5V2.5C3.375 2.70711 3.20711 2.875 3 2.875C2.79289 2.875 2.625 2.70711 2.625 2.5Z"
        fill={color}
      />
      <path
        d="M8.625 2.5V1.5C8.625 1.29289 8.79289 1.125 9 1.125C9.20711 1.125 9.375 1.29289 9.375 1.5V2.5C9.375 2.70711 9.20711 2.875 9 2.875C8.79289 2.875 8.625 2.70711 8.625 2.5Z"
        fill={color}
      />
      <path
        d="M4.625 2.5V1.5C4.625 1.29289 4.79289 1.125 5 1.125C5.20711 1.125 5.375 1.29289 5.375 1.5V2.5C5.375 2.70711 5.20711 2.875 5 2.875C4.79289 2.875 4.625 2.70711 4.625 2.5Z"
        fill={color}
      />
      <path
        d="M6.625 2.5V1.5C6.625 1.29289 6.79289 1.125 7 1.125C7.20711 1.125 7.375 1.29289 7.375 1.5V2.5C7.375 2.70711 7.20711 2.875 7 2.875C6.79289 2.875 6.625 2.70711 6.625 2.5Z"
        fill={color}
      />
      <path
        d="M10.5 10.25C10.5 10.3881 10.3881 10.5 10.25 10.5H1.75C1.61193 10.5 1.5 10.3881 1.5 10.25V4H10.5V10.25ZM3.75 5.5C3.33579 5.5 3 5.83579 3 6.25C3 6.66421 3.33579 7 3.75 7C4.16421 7 4.5 6.66421 4.5 6.25C4.5 5.83579 4.16421 5.5 3.75 5.5Z"
        fill={color}
      />
    </svg>
  );
};

export default ICalendar;
